import React from 'react'
import PropTypes from 'prop-types'
import { Field } from 'redux-form'
import {
  utils,
  Form,
  MorpheusReduxFormFields,
  StatusIcon,
  coreConstants,
} from '@adc/ui-morpheus'
import _ from 'lodash'
import { venueHelpContent } from '../../constants/tooltips'
import { isUrlEmpty } from '../../util/common'
const {
  DatePickerField,
  DropdownField,
  TextAreaField,
  InputWithDropdownField,
  TimeField,
} = MorpheusReduxFormFields
const {
  validate: { length, date, validUrl, validTime },
} = utils
const { UI_DATE_FORMAT } = coreConstants.statics

const VenuesBulkUpdateForm = ({ handleSubmit, onSubmit }) => {
  return (
    <Form padded={false} onSubmit={handleSubmit(onSubmit)} noValidate>
      <Form.Content>
        <Form.Column colSize='full'>
          <Form.Section title='Venue Attributes'>
            <Field
              name='webLiveStatus'
              label='Web Live Status'
              elmId='web_live_status'
              options={[
                {
                  value: true,
                  text: (
                    <span>
                      <StatusIcon active /> Active
                    </span>
                  ),
                },
                {
                  value: false,
                  text: (
                    <span>
                      <StatusIcon active={false} /> Inactive
                    </span>
                  ),
                },
              ]}
              helpContent={venueHelpContent.WEB_LIVE_STATUS}
              component={DropdownField}
            />
            <Field
              name='venueName'
              label='Venue Name'
              elmId='venue_name'
              validate={[length({ in: [5, 255], allowBlank: true })]}
              helpContent={venueHelpContent.VENUE_NAME}
              component={TextAreaField}
              normalizeOnBlur={_.trim}
            />
            <Field
              name='venueTitle'
              label='Venue Title'
              elmId='venue_title'
              validate={[length({ in: [5, 255], allowBlank: true })]}
              helpContent={venueHelpContent.VENUE_TITLE}
              component={TextAreaField}
              normalizeOnBlur={_.trim}
            />
            <Field
              name='auctionStartDate'
              label='Auction Start Date'
              elmId='auction_start_date'
              validate={[
                date({
                  allowBlank: true,
                  format: UI_DATE_FORMAT,
                  msg: 'Invalid date',
                  ymd: 'YMD',
                }),
              ]}
              helpContent={venueHelpContent.AUCTION_START_DATE}
              component={DatePickerField}
            />
            <Field
              name='bidStartTime'
              label='Bid Start Time'
              elmId='bid_start_time'
              helpContent={venueHelpContent.BID_START_TIME}
              validate={[validTime({ allowBlank: true })]}
              component={TimeField}
            />
            <Field
              name='auctionEndDate'
              label='Auction End Date'
              elmId='auction_end_date'
              validate={[
                date({
                  allowBlank: true,
                  format: UI_DATE_FORMAT,
                  msg: 'Invalid date',
                  ymd: 'YMD',
                }),
              ]}
              helpContent={venueHelpContent.AUCTION_END_DATE}
              component={DatePickerField}
            />
            <Field
              name='bidEndTime'
              label='Bid End Time'
              elmId='bid_end_time'
              helpContent={venueHelpContent.BID_END_TIME}
              validate={[validTime({ allowBlank: true })]}
              component={TimeField}
            />
            <Field
              name='registrationTime'
              label='Registration Time'
              elmId='registration_time'
              helpContent={venueHelpContent.REGISTRATION_TIME}
              validate={[validTime({ allowBlank: true })]}
              component={TimeField}
            />
            <Field
              name='venueUrl'
              label='Venue URL'
              elmId='venue_url'
              dropdownOptions={[
                { key: 'http', text: 'http://', value: 'http://' },
                { key: 'https', text: 'https://', value: 'https://' },
              ]}
              dropdownDefault='http://'
              splitValue={val => val.match(/(^http:\/\/|^https:\/\/)|(.*$)/g)}
              validate={[
                length({
                  in: [10, 255],
                  allowBlank: true,
                  unless: isUrlEmpty,
                }),
                validUrl({ allowBlank: true, unless: isUrlEmpty }),
              ]}
              helpContent={venueHelpContent.VENUE_URL}
              component={InputWithDropdownField}
            />
          </Form.Section>
        </Form.Column>
      </Form.Content>
    </Form>
  )
}

VenuesBulkUpdateForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
}

export default VenuesBulkUpdateForm
